"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTreatRecordList = getTreatRecordList;
var _request = _interopRequireDefault(require("@/utils/request"));
function getTreatRecordList(query) {
  return (0, _request.default)({
    url: '/system/treatmentrecord/',
    method: 'get',
    params: query
  });
}